import { breakpoints } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { colors } from "../../../utils/colors";

export enum Appearances {
    primary = "primary",
    secondary = "secondary",
}

export const Wrapper = styled(Link)<{ appearance: Appearances }>`
    display: block;
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    padding-bottom: 137%;
    box-shadow: 0 5px 10px ${transparentize(0.8, "black")};
    transition: 200ms ease all;
    transform: translateY(0) translateZ(0);

    [data-whatintent="mouse"] &:hover {
        transform: translateY(-5px) translateZ(0);
        box-shadow: 0 15px 25px ${transparentize(0.8, "black")};
    }

    ${breakpoints.large} {
        padding-bottom: 45%;
    }

    ${({ appearance }) => {
        switch (appearance) {
            case Appearances.primary:
                return css`
                    background-color: ${colors.brandMid};
                `;
            case Appearances.secondary:
                return css`
                    background-color: white;

                    ${Title} {
                        color: ${colors.brandMid};
                    }
                `;
        }
    }}
`;

export const Inner = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    ${breakpoints.large} {
        display: flex;
        align-items: center;
        padding: 24px;
        gap: 16px;
    }
`;

export const Image = styled.img`
    width: 100%;
    height: auto;
    border-top-left-radius: 27px;
    border-top-right-radius: 27px;

    ${breakpoints.large} {
        width: 150px;
        padding: 0;
    }
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 40%;
    padding: 12px 16px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    ${breakpoints.large} {
        position: relative;
        width: auto;
        padding: 0;
        min-height: auto;
    }
`;

export const Title = styled.h4<{ useSmallerText?: boolean }>`
    margin: 0;
    color: ${colors.white};
    font-size: 19px;

    ${({ useSmallerText }) =>
        useSmallerText &&
        css`
            font-size: 16px;
        `}

    ${breakpoints.large} {
        font-size: 22px;
        ${({ useSmallerText }) =>
            useSmallerText &&
            css`
                font-size: 18px;
            `}
    }
`;
